module.exports = __webpack_public_path__ + "img/same_person_title.386d5655.png";